import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { InfoPostDetails, InfoPostRequest } from '@gms/reporting-api';
import { select, Store } from '@ngrx/store';
import { excludeInfoPostMap, selectAllPostingsList, selectExcludeInfoPostTsp } from 'app/store/infopost/infopost.selectors';
import { IInfoPostState } from 'app/store/infopost/infopost.state';
import { Observable } from 'rxjs';
import { FileSelectService } from 'shared/components/form/file-select/file-select.service';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { InformationalWebLabels, MenuItems } from '../../informational-posting-web.utils';
import {
  infoPostingSort,
  postingTableConfig,
} from '../informational-postings-shared-table/informational-postings-shared-table';
import { cancelRequest, fetchPostingsList } from 'app/store/infopost/infopost.actions';
import { filter, map, tap } from 'rxjs/operators';
import { isNullOrUndefined } from 'shared/utils/type.utils';
import { TableConfig } from 'shared/components/table/table.interfaces';
import { LoadingSpinnerModule } from 'shared/components/loading-spinner/loading-spinner.module';
import { ToastService } from 'shared/services/toast.service';
import { TSPEnum } from 'app/components/app-common-views/infopost-nav-container/sidebar-nav/nav-menus.constants';

@Component({
  selector: 'app-infopost-pipeline-map',
  standalone: true,
  imports: [CommonModule, LoadingSpinnerModule],
  templateUrl: './infopost-pipeline-map.component.html',
  styleUrls: ['./infopost-pipeline-map.component.scss'],
})
export class InfopostPipelineMapComponent extends HasSubscriptions implements OnInit, OnDestroy {
  @Input() selectedTspID: number;

  infoPostId: number = MenuItems.TSPMAP;
  thumbnailImgPath: string = null;
  detailedPdfPath: string = null;
  tableConfig: TableConfig = postingTableConfig;

  postingList$: Observable<InfoPostDetails> = this._store.pipe(
    select(selectAllPostingsList),
    filter((data) => !isNullOrUndefined(data)),
    map((data) => data)
  );

  execludeTsp$: Observable<boolean> = this._store.pipe(
    select(selectExcludeInfoPostTsp),
    filter((data) => !isNullOrUndefined(data)),
    map(excludeTsp =>{
      return excludeTsp.some((x) => x.providerId === this.selectedTspID);
    })
  );

  excludeInfoPostMap$: Observable<boolean> = this._store.pipe(
    select(excludeInfoPostMap),
    filter((data) => !isNullOrUndefined(data)),
    map(excludeTsp =>{
      return excludeTsp.some((x) => x.providerId === this.selectedTspID);
    })
  );

  infoPostTrackerID: number;

  constructor(
    private _store: Store<IInfoPostState>,
    private _fileService: FileSelectService,
    private _toastService: ToastService
  ) {
    super();
  }

  ngOnInit() {

    this.fetchTableData();
    this.addSubscriptions([
      this.execludeTsp$
        .pipe(
          tap((isExcluded) => {
            const currentTspID = isExcluded ? TSPEnum.BOARDWALK : this.selectedTspID;
            const thumbnailFileName = 'map-' + currentTspID + '.svg';
            const detailedFileName = 'map-' + currentTspID + '-detailed.pdf';
            this.thumbnailImgPath = '/assets/svg/' + thumbnailFileName;
            this.detailedPdfPath = '/assets/svg/' + detailedFileName;
          })
        ).subscribe(),

      this.postingList$.subscribe((resp) => {
        let postings = resp.postings;
        if (postings && postings.length > 0) {
          let reportFiles = postings[0].reportFiles;
          if (reportFiles.length > 0) {
            this.infoPostTrackerID = reportFiles[0].infoPostTrackerID;
          }
        }
      }),
    ]);
  }

  downloadDocument() {
    if (this.infoPostTrackerID) {
      this._fileService.dispatchDownloadDocument(
        this.infoPostTrackerID,
        InformationalWebLabels.DOWNLOADTYPEPOSTING
      );
    } else {
      this._toastService.showError(InformationalWebLabels.DOCUMENTID_ISSUE);
    }
  }

  private fetchTableData(): void {
    const { pageNumber, pageSize } = this.tableConfig.pagination;
    const payLoad: InfoPostRequest = {
      infoPostID: this.infoPostId,
      tspId: this.selectedTspID,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortBy: infoPostingSort[0].field,
      sortDescending: true,
      groupCode: InformationalWebLabels.INFOPOST
    };

    this._store.dispatch(fetchPostingsList({ posting: payLoad }));
  }

  ngOnDestroy() {
    this._store.dispatch(cancelRequest());
    return super.ngOnDestroy();
  }
}
